import { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { State } from '../../types/state'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useMobile } from '../../hooks/useMobile'
import PersonIcon from '@mui/icons-material/Person'
import MessageIcon from '@mui/icons-material/Message'
import AssignmentIcon from '@mui/icons-material/Assignment'
import TaskIcon from '@mui/icons-material/Task'
import BusinessIcon from '@mui/icons-material/Business'
import LogoutIcon from '@mui/icons-material/Logout'
import { UserActions } from '../../state/user'
import { useRequests } from '../../requests/useRequests'

export const SideMenu = () => {
  const [activeItem, setActiveItem] = useState<string>('profile')
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const requestMaker = useRequests()
  const { isSuperadmin, package: userPackage, packageExpiredAt } = useSelector((state: State) => state.user)

  const isMobile = useMobile()

  useEffect(() => {
    const path = location.pathname.split('/')[1]
    if (path) setActiveItem(path)
  }, [location])

  const handleLogout = (): void => {
    localStorage.removeItem('Kreatlo-username')
    localStorage.removeItem('Kreatlo-password')
    localStorage.removeItem('Kreatlo-jwtToken')
    localStorage.removeItem('Kreatlo-googleToken')
    dispatch(UserActions.reset())
    navigate('/')
  }

  if (isMobile) {
    return <></>
  }

  const menuItems = [
    {
      id: 'user-profile',
      label: 'Profil',
      path: '/user-profile',
      icon: <PersonIcon />
    },
    {
      id: 'messages',
      label: 'Wiadomości',
      path: '/messages',
      icon: <MessageIcon />
    },
    {
      id: 'projects',
      label: 'Projekty',
      path: '/projects',
      icon: <AssignmentIcon />
    },
    {
      id: 'tasks',
      label: 'Zadania',
      path: '/tasks',
      icon: <TaskIcon />, 
    },
    // {
    //   id: 'plants',
    //   label: 'Rośliny',
    //   path: '/plants'
    // },
    isSuperadmin
      ? {
          id: 'nurseries',
          label: 'Szkółki',
          path: '/nurseries',
          icon: <BusinessIcon />
        }
      : null,
    {
      id: 'logout',
      label: 'Wyloguj',
      path: '/',
      icon: <LogoutIcon />
    }
  ].filter(item => !(item == null)) as any[]

  // return <></>

  return (
    <>
      <div
        className='side-menu' style={{
          position: 'sticky',
          top: '0',
          bottom: '0',
          minHeight: '100%',
          backgroundColor: '#0d2d42',
          borderRight: '1px solid #0a2231',
          padding: '24px 0',
          width: '250px',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <h3 style={{
          margin: '0 0 24px 24px',
          fontSize: '24px',
          fontWeight: 400,
          color: '#ffffff'
        }}
        >
          Panel
        </h3>
        <nav style={{ flex: 1 }}>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}
          >
            {menuItems.map((item) => (
              <li
                key={item.id} className='menu-item' style={{
                  marginBottom: '8px',
                  padding: '0 12px'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Link
                      to={item.path}
                      onClick={() => {
                        if (item.id === 'logout') {
                          handleLogout()
                        } else {
                          setActiveItem(item.id)
                        }
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 16px',
                        color: activeItem === item.id ? '#ffffff' : '#ffffff',
                        textDecoration: 'none',
                        fontSize: '15px',
                        fontWeight: 400,
                        backgroundColor: activeItem === item.id ? '#13354a' : 'transparent',
                        borderRadius: '8px',
                        transition: 'all 0.2s ease',
                        border: '1px solid transparent',
                        flex: 1
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#13354a'
                        e.currentTarget.style.borderColor = '#ffffff'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = activeItem === item.id ? '#13354a' : 'transparent'
                        e.currentTarget.style.borderColor = 'transparent'
                      }}
                    >
                      {item.icon}
                      {item.label}
                    </Link>
                </div>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  )
}
